import React, { useState, useEffect, useRef } from "react";

import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";

import "./_confirm-deletion.scss";

type OwnProps = {
    onUserConfirm: (confirmed: boolean) => void;
    className?: string;
    titleText: string;
    bodyText: string;
    size?: "small" | "medium" | "large";
    buttonText?: string;
    disabled?: boolean;
    disabledReasonMessage?: string;
};

export const ConfirmDeletion = (props: OwnProps) => {
    const { t } = useTranslation();
    const [active, setActive] = useState(false);
    const [confirmed, setConfirmed] = useState(false);
    const confirmContent = useRef<HTMLDivElement>(null);

    const handleOutsideClick = (event: MouseEvent) => {
        if (
            (confirmContent.current && !confirmContent.current.contains(event.target as Node)) ||
            confirmContent.current === event.target
        ) {
            setActive(false);
        }
    };

    const handleOpenPopup = (event: React.MouseEvent) => {
        event.preventDefault();
        setActive(!active);
    };

    const handleConfirm = () => {
        setConfirmed(!confirmed);
        props.onUserConfirm(confirmed);
    };

    useEffect(() => {
        if (active) {
            document.addEventListener("mousedown", handleOutsideClick);
        }
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [confirmContent, active]);

    return (
        <div className={`confirm-deletion ${props.className || ""}`} ref={confirmContent}>
            <Button
                variant="contained"
                color="secondary"
                className="confirm-deletion__button"
                startIcon={<FontAwesomeIcon icon={faTrash} />}
                onClick={handleOpenPopup}
                size={props.size}
                disabled={props.disabled}
            >
                {props.buttonText ? props.buttonText : t("Gui.Buttons.Delete")}
            </Button>
            {props.disabled && props.disabledReasonMessage ? (
                <div className="confirm-deletion__disabled-hint caption">{props.disabledReasonMessage}</div>
            ) : null}
            {active ? (
                <div className="confirm-deletion__content confirm-deletion__content--active">
                    <h3 className="confirm-deletion__title">{props.titleText}</h3>
                    <p className="confirm-deletion__paragraph">{props.bodyText}</p>
                    <div className="confirm-deletion__buttons">
                        <Button size="small" color="default" onClick={() => setActive(false)}>
                            {t("Gui.Buttons.Cancel")}
                        </Button>
                        <Button
                            className="confirm-deletion__button"
                            variant="contained"
                            size="small"
                            color="secondary"
                            onClick={handleConfirm}
                        >
                            {t("Gui.Buttons.Delete")}
                        </Button>
                    </div>
                </div>
            ) : null}
        </div>
    );
};
